import luda from '../base/luda.coffee'
import './get.coffee'



luda.include
  
  eq: (index) -> luda @get(index)